import '@/assets/reset.css'

import Vue from 'vue'
import App from './App.vue'

import _ from 'underscore'
import moment from 'moment'
import VTooltip from 'v-tooltip'
import PortalVue from 'portal-vue'

import constants from './constants'

import store from './service/store'
import router from './service/router'
import pubsub from './service/pubsub'
import api from './service/api'

import injection from './mixin/injection'
import shortcuts from './mixin/shortcuts'
import mwindow from './mixin/window'

import { CookieStorage } from 'cookie-storage'

var cookies = new CookieStorage({
	path: '/',
	expires: moment().add('1', 'y').toDate()
})

Vue.config.productionTip = false

if (cookies.getItem('copd_profiles') === null) cookies.setItem('copd_profiles', '{}')

var requireComponentGlobal = require.context('./components/common', true, /[A-Z]\w+\.(vue|js)$/)

requireComponentGlobal.keys().forEach(function(filename) {

	var componentConfig = requireComponentGlobal(filename)
	var componentName = 'app' + filename.replace(/\//g, '-').replace('.vue', '').replace('.', '').toLowerCase()

	Vue.component(
		componentName,
		componentConfig.default
	)

})

Vue.filter('formatDate', function (value, format) {

	return (value) ? moment.unix(value).local().format(format) : ''

})

Vue.mixin(mwindow)
Vue.mixin(injection)
Vue.mixin(shortcuts)

Vue.use(PortalVue)
Vue.use(VTooltip)

new Vue({
	_,
	store,
	router,
	api,
	constants,
	moment,
	cookies,
	pubsub,
	render: h => h(App),
	created: function() {

		pubsub.$emit('window.initiated')

	}
}).$mount('#app')